import { z } from "zod";
export const SalesRoomVisibilityPolicyV1Schema = z
    .object({
    schemaVersion: z.literal("sales-room-visibility-policy.v1.0"),
    showClassABlockers: z.literal(true),
    showMaterialClassBExceptions: z.literal(true),
    hideRawQgLogs: z.literal(true),
    hideManifests: z.literal(true),
    hideInternalRunIds: z.literal(true),
    hideArtifactHashes: z.literal(true),
})
    .strict();
export const SalesRoomProofSummaryV1Schema = z
    .object({
    schemaVersion: z.literal("sales-room-proof-summary.v1.0"),
    headline: z.string().min(1),
    readinessLabel: z.string().min(1),
    releaseLabel: z.string().min(1),
    proofHighlights: z.array(z.string()),
    blockers: z.array(z.string()),
    warnings: z.array(z.string()),
})
    .strict();
export const SalesRoomProofStoryV1Schema = z
    .object({
    schemaVersion: z.literal("sales-room-proof-story.v1.0"),
    talkTrack: z.array(z.string()),
    proofCards: z.array(z.object({ title: z.string(), body: z.string(), evidenceType: z.string().optional() }).strict()),
    summary: SalesRoomProofSummaryV1Schema,
})
    .strict();
export const SalesRoomClientSafeSnapshotV1Schema = z
    .object({
    schemaVersion: z.literal("sales-room-client-safe-snapshot.v1.0"),
    previewUrl: z.string().url().optional(),
    approvalEnabled: z.boolean(),
    staleArtifact: z.boolean(),
    proofStory: SalesRoomProofStoryV1Schema,
})
    .strict();
export const SalesRoomConfigV1Schema = z
    .object({
    schemaVersion: z.literal("sales-room-config.v1.0"),
    visibilityPolicy: SalesRoomVisibilityPolicyV1Schema,
    enabled: z.boolean().default(true),
})
    .strict();
export const DEFAULT_SALES_ROOM_VISIBILITY_POLICY = SalesRoomVisibilityPolicyV1Schema.parse({
    schemaVersion: "sales-room-visibility-policy.v1.0",
    showClassABlockers: true,
    showMaterialClassBExceptions: true,
    hideRawQgLogs: true,
    hideManifests: true,
    hideInternalRunIds: true,
    hideArtifactHashes: true,
});
//# sourceMappingURL=sales-room.js.map